import React from "react";

import StdButton from "components/Buttons/StdButton";
import { useBtnLoading } from "store/btnLoading";

function ButtonForm(props) {
  // This option is useless because factoryField resolve
  const { field, attrs } = props;
  const {
    name,
    label,
    disabled,
    color,
    iconRight,
    iconLeft,
    style = false,
  } = field;
  const { handleButton } = attrs;
  const { loadingBtn } = useBtnLoading();

  async function onClick(e) {
    e.preventDefault();
    await handleButton(name);
  }

  const _color = color ?? "green";
  return (
    <div className="py-2 sm:py-4">
      <StdButton
        key={name}
        name={name}
        onClick={onClick}
        color={_color}
        content={label}
        disabled={disabled}
        loading={loadingBtn}
        iconRight={iconRight || false}
        iconLeft={iconLeft || false}
        style={style}
      />
    </div>
  );
}

export default ButtonForm;
